import { defineComponent as _defineComponent } from 'vue'
import useCollectionUtils from '@/resources/collections/use-collection-utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'PolylinoCollectionIcons',
  setup(__props) {

const { CollectionsAvailableIcons, icons } = useCollectionUtils();

return { __sfc: true,CollectionsAvailableIcons, icons }
}

})